//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAssemblyClient {

    getAssembly(id: string | undefined): Promise<AssemblyDto>;

    getOneAssemblyFromHistoric(id: string | undefined, patitionKey: string | null | undefined): Promise<Assembly>;

    getAssemblies(query: GetAllAssembliesQuery | null | undefined): Promise<AssemblyHeaderDto[]>;

    getPublicAndPrivateAssemblies(query: GetAllAssembliesForOrganizationCompleteQuery | null | undefined): Promise<Assembly[]>;

    getPublicAndPrivateAssemblies2(query: GetAllAssembliesForOrganizationCompleteQuery | null | undefined): Promise<Assembly[]>;

    getAssembliesComplete(query: GetAllAssembliesCompleteQuery | null | undefined): Promise<AssemblyDto[]>;

    getAssembliesAndReferencesComplete(query: GetAllAssembliesAndReferencesCompleteQuery | null | undefined): Promise<AssemblyDto[]>;

    saveAssembly(command: SaveAssemblyCommand): Promise<AssemblyDto>;

    duplicateAssembly(command: DuplicateAssemblyCommand): Promise<Assembly>;

    duplicateAssemblyReference(command: DuplicateAssemblyReferenceCommand): Promise<AssemblyDto>;

    duplicateReferenceToReference(command: DuplicateReferenceToReferenceCommand): Promise<Assembly>;

    deleteAssembly(command: DeleteAssemblyCommand): Promise<Assembly>;

    getAssemblyHistory(id: string | undefined): Promise<AssemblyDto[]>;

    validateAssemblyName(id: string | undefined, name: string | null | undefined, type: string | null | undefined): Promise<boolean>;

    refactorParametersAssemblies(command: RefactorAssemblyCommand): Promise<Assembly[]>;

    refactorSizeAssemblies(command: RefactorSizeAssemblyCommand): Promise<Assembly[]>;

    copyToCosmos(command: CopyToCosmosCommand): Promise<Assembly[]>;

    refactorCoordinateAssemblies(command: RefactorViewerAssemblyCommand): Promise<Assembly[]>;

    sharePublicAssemblies(command: SharePublicAssemblyCommand): Promise<boolean>;
}

export class AssemblyClient implements IAssemblyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAssembly(id: string | undefined): Promise<AssemblyDto> {
        let url_ = this.baseUrl + "/api/Assembly/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssembly(_response);
        });
    }

    protected processGetAssembly(response: Response): Promise<AssemblyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssemblyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto>(null as any);
    }

    getOneAssemblyFromHistoric(id: string | undefined, patitionKey: string | null | undefined): Promise<Assembly> {
        let url_ = this.baseUrl + "/api/Assembly/get/one/history?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (patitionKey !== undefined && patitionKey !== null)
            url_ += "PatitionKey=" + encodeURIComponent("" + patitionKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOneAssemblyFromHistoric(_response);
        });
    }

    protected processGetOneAssemblyFromHistoric(response: Response): Promise<Assembly> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assembly.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly>(null as any);
    }

    getAssemblies(query: GetAllAssembliesQuery | null | undefined): Promise<AssemblyHeaderDto[]> {
        let url_ = this.baseUrl + "/api/Assembly/get/all?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssemblies(_response);
        });
    }

    protected processGetAssemblies(response: Response): Promise<AssemblyHeaderDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssemblyHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyHeaderDto[]>(null as any);
    }

    getPublicAndPrivateAssemblies(query: GetAllAssembliesForOrganizationCompleteQuery | null | undefined): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/get/publicandprivate?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicAndPrivateAssemblies(_response);
        });
    }

    protected processGetPublicAndPrivateAssemblies(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    getPublicAndPrivateAssemblies2(query: GetAllAssembliesForOrganizationCompleteQuery | null | undefined): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/get/all/organization/complete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicAndPrivateAssemblies2(_response);
        });
    }

    protected processGetPublicAndPrivateAssemblies2(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    getAssembliesComplete(query: GetAllAssembliesCompleteQuery | null | undefined): Promise<AssemblyDto[]> {
        let url_ = this.baseUrl + "/api/Assembly/get/all/complete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssembliesComplete(_response);
        });
    }

    protected processGetAssembliesComplete(response: Response): Promise<AssemblyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssemblyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto[]>(null as any);
    }

    getAssembliesAndReferencesComplete(query: GetAllAssembliesAndReferencesCompleteQuery | null | undefined): Promise<AssemblyDto[]> {
        let url_ = this.baseUrl + "/api/Assembly/get/assembliesandreferences/complete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssembliesAndReferencesComplete(_response);
        });
    }

    protected processGetAssembliesAndReferencesComplete(response: Response): Promise<AssemblyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssemblyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto[]>(null as any);
    }

    saveAssembly(command: SaveAssemblyCommand): Promise<AssemblyDto> {
        let url_ = this.baseUrl + "/api/Assembly/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAssembly(_response);
        });
    }

    protected processSaveAssembly(response: Response): Promise<AssemblyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssemblyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto>(null as any);
    }

    duplicateAssembly(command: DuplicateAssemblyCommand): Promise<Assembly> {
        let url_ = this.baseUrl + "/api/Assembly/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateAssembly(_response);
        });
    }

    protected processDuplicateAssembly(response: Response): Promise<Assembly> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assembly.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly>(null as any);
    }

    duplicateAssemblyReference(command: DuplicateAssemblyReferenceCommand): Promise<AssemblyDto> {
        let url_ = this.baseUrl + "/api/Assembly/duplicate/reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateAssemblyReference(_response);
        });
    }

    protected processDuplicateAssemblyReference(response: Response): Promise<AssemblyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssemblyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto>(null as any);
    }

    duplicateReferenceToReference(command: DuplicateReferenceToReferenceCommand): Promise<Assembly> {
        let url_ = this.baseUrl + "/api/Assembly/duplicate/referencetoreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateReferenceToReference(_response);
        });
    }

    protected processDuplicateReferenceToReference(response: Response): Promise<Assembly> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assembly.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly>(null as any);
    }

    deleteAssembly(command: DeleteAssemblyCommand): Promise<Assembly> {
        let url_ = this.baseUrl + "/api/Assembly/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssembly(_response);
        });
    }

    protected processDeleteAssembly(response: Response): Promise<Assembly> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Assembly.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly>(null as any);
    }

    getAssemblyHistory(id: string | undefined): Promise<AssemblyDto[]> {
        let url_ = this.baseUrl + "/api/Assembly/history?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssemblyHistory(_response);
        });
    }

    protected processGetAssemblyHistory(response: Response): Promise<AssemblyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssemblyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssemblyDto[]>(null as any);
    }

    validateAssemblyName(id: string | undefined, name: string | null | undefined, type: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Assembly/validate/name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateAssemblyName(_response);
        });
    }

    protected processValidateAssemblyName(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    refactorParametersAssemblies(command: RefactorAssemblyCommand): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/refactor/parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefactorParametersAssemblies(_response);
        });
    }

    protected processRefactorParametersAssemblies(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    refactorSizeAssemblies(command: RefactorSizeAssemblyCommand): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/refactor/size";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefactorSizeAssemblies(_response);
        });
    }

    protected processRefactorSizeAssemblies(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    copyToCosmos(command: CopyToCosmosCommand): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/refactor/cosmos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyToCosmos(_response);
        });
    }

    protected processCopyToCosmos(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    refactorCoordinateAssemblies(command: RefactorViewerAssemblyCommand): Promise<Assembly[]> {
        let url_ = this.baseUrl + "/api/Assembly/refactor/coordinates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefactorCoordinateAssemblies(_response);
        });
    }

    protected processRefactorCoordinateAssemblies(response: Response): Promise<Assembly[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assembly[]>(null as any);
    }

    sharePublicAssemblies(command: SharePublicAssemblyCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Assembly/refactor/sharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSharePublicAssemblies(_response);
        });
    }

    protected processSharePublicAssemblies(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ICustomComponentClient {

    getAllAssemblies(id: string | undefined): Promise<CustomComponent>;

    getAssembly(query: GetAllCustomComponentsQuery | null | undefined): Promise<CustomComponent[]>;

    saveAssembly(command: SaveCustomComponentCommand): Promise<CustomComponent>;

    deleteAssembly(command: DeleteCustomComponentCommand): Promise<CustomComponent>;

    refactorParametersAssemblies(command: RefactorCustomComponentCommand): Promise<CustomComponent[]>;

    refactorSizeAssemblies(command: RefactorSizeCustomComponentCommand): Promise<CustomComponent[]>;

    copyToCosmos(command: CopyToCosmosCommand2): Promise<CustomComponent[]>;
}

export class CustomComponentClient implements ICustomComponentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllAssemblies(id: string | undefined): Promise<CustomComponent> {
        let url_ = this.baseUrl + "/api/CustomComponent/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAssemblies(_response);
        });
    }

    protected processGetAllAssemblies(response: Response): Promise<CustomComponent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomComponent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent>(null as any);
    }

    getAssembly(query: GetAllCustomComponentsQuery | null | undefined): Promise<CustomComponent[]> {
        let url_ = this.baseUrl + "/api/CustomComponent/get/all?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssembly(_response);
        });
    }

    protected processGetAssembly(response: Response): Promise<CustomComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent[]>(null as any);
    }

    saveAssembly(command: SaveCustomComponentCommand): Promise<CustomComponent> {
        let url_ = this.baseUrl + "/api/CustomComponent/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAssembly(_response);
        });
    }

    protected processSaveAssembly(response: Response): Promise<CustomComponent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomComponent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent>(null as any);
    }

    deleteAssembly(command: DeleteCustomComponentCommand): Promise<CustomComponent> {
        let url_ = this.baseUrl + "/api/CustomComponent/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssembly(_response);
        });
    }

    protected processDeleteAssembly(response: Response): Promise<CustomComponent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomComponent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent>(null as any);
    }

    refactorParametersAssemblies(command: RefactorCustomComponentCommand): Promise<CustomComponent[]> {
        let url_ = this.baseUrl + "/api/CustomComponent/refactor/parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefactorParametersAssemblies(_response);
        });
    }

    protected processRefactorParametersAssemblies(response: Response): Promise<CustomComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent[]>(null as any);
    }

    refactorSizeAssemblies(command: RefactorSizeCustomComponentCommand): Promise<CustomComponent[]> {
        let url_ = this.baseUrl + "/api/CustomComponent/refactor/size";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefactorSizeAssemblies(_response);
        });
    }

    protected processRefactorSizeAssemblies(response: Response): Promise<CustomComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent[]>(null as any);
    }

    copyToCosmos(command: CopyToCosmosCommand2): Promise<CustomComponent[]> {
        let url_ = this.baseUrl + "/api/CustomComponent/refactor/cosmos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyToCosmos(_response);
        });
    }

    protected processCopyToCosmos(response: Response): Promise<CustomComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomComponent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomComponent[]>(null as any);
    }
}

export interface IDirectoryClient {

    getAllDirectories(query: GetAllDirectoriesFromOrganizationQuery | null | undefined): Promise<DirectoryFolder[]>;

    deleteDirectory(command: DeleteDirectoryCommand): Promise<DirectoryFolder>;

    saveDirectory(command: SaveDirectoryCommand): Promise<DirectoryFolder>;
}

export class DirectoryClient implements IDirectoryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllDirectories(query: GetAllDirectoriesFromOrganizationQuery | null | undefined): Promise<DirectoryFolder[]> {
        let url_ = this.baseUrl + "/api/Directory/get/all?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDirectories(_response);
        });
    }

    protected processGetAllDirectories(response: Response): Promise<DirectoryFolder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectoryFolder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DirectoryFolder[]>(null as any);
    }

    deleteDirectory(command: DeleteDirectoryCommand): Promise<DirectoryFolder> {
        let url_ = this.baseUrl + "/api/Directory/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDirectory(_response);
        });
    }

    protected processDeleteDirectory(response: Response): Promise<DirectoryFolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectoryFolder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DirectoryFolder>(null as any);
    }

    saveDirectory(command: SaveDirectoryCommand): Promise<DirectoryFolder> {
        let url_ = this.baseUrl + "/api/Directory/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDirectory(_response);
        });
    }

    protected processSaveDirectory(response: Response): Promise<DirectoryFolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectoryFolder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DirectoryFolder>(null as any);
    }
}

export interface IImageClient {

    uploadScreenshotSvg(file: FileParameter | null | undefined): Promise<FileResponse>;

    uploadScreenshot(file: FileParameter | null | undefined): Promise<FileResponse>;

    uploadScreenshotComponentSvg(file: FileParameter | null | undefined): Promise<FileResponse>;

    uploadScreenshotComponent(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class ImageClient implements IImageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    uploadScreenshotSvg(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Image/upload/svg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadScreenshotSvg(_response);
        });
    }

    protected processUploadScreenshotSvg(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadScreenshot(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Image/upload/png";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadScreenshot(_response);
        });
    }

    protected processUploadScreenshot(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadScreenshotComponentSvg(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Image/upload/component/svg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadScreenshotComponentSvg(_response);
        });
    }

    protected processUploadScreenshotComponentSvg(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadScreenshotComponent(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Image/upload/component/png";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadScreenshotComponent(_response);
        });
    }

    protected processUploadScreenshotComponent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPermissionClient {

    hasAssemblyPermission(id: string | undefined): Promise<ActionPermission>;
}

export class PermissionClient implements IPermissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    hasAssemblyPermission(id: string | undefined): Promise<ActionPermission> {
        let url_ = this.baseUrl + "/api/Permission/assembly?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasAssemblyPermission(_response);
        });
    }

    protected processHasAssemblyPermission(response: Response): Promise<ActionPermission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionPermission.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionPermission>(null as any);
    }
}

export interface IPreviewClient {

    saveAssembly(command: CopyContainersCommand): Promise<boolean>;

    changeDuplicateSua(command: ChangeDuplicateSameSuaCommand): Promise<boolean>;

    addAllSuaInHistory(command: AddAllSuaInHistoryCommand): Promise<boolean>;

    addHashPartitionKey(command: AddHashPartitionKeyCommand): Promise<boolean>;

    addVersionHashPartitionKeyUo(command: AddVersionHashPartitionKeyUoCommand): Promise<{ [key: string]: string[]; }>;
}

export class PreviewClient implements IPreviewClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    saveAssembly(command: CopyContainersCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Preview/copyPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAssembly(_response);
        });
    }

    protected processSaveAssembly(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    changeDuplicateSua(command: ChangeDuplicateSameSuaCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Preview/changeDuplicateSua";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeDuplicateSua(_response);
        });
    }

    protected processChangeDuplicateSua(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    addAllSuaInHistory(command: AddAllSuaInHistoryCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Preview/addAllSUAInHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAllSuaInHistory(_response);
        });
    }

    protected processAddAllSuaInHistory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    addHashPartitionKey(command: AddHashPartitionKeyCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Preview/addHashPartitionKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddHashPartitionKey(_response);
        });
    }

    protected processAddHashPartitionKey(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    addVersionHashPartitionKeyUo(command: AddVersionHashPartitionKeyUoCommand): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/Preview/addVersionHashPartitionKeyUO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVersionHashPartitionKeyUo(_response);
        });
    }

    protected processAddVersionHashPartitionKeyUo(response: Response): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }
}

export interface ISharingClient {

    shareAssembly(command: ShareAssemblyCommand): Promise<Shareable>;

    getShareable(id: string | undefined): Promise<Shareable>;
}

export class SharingClient implements ISharingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    shareAssembly(command: ShareAssemblyCommand): Promise<Shareable> {
        let url_ = this.baseUrl + "/api/Sharing/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShareAssembly(_response);
        });
    }

    protected processShareAssembly(response: Response): Promise<Shareable> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shareable.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Shareable>(null as any);
    }

    getShareable(id: string | undefined): Promise<Shareable> {
        let url_ = this.baseUrl + "/api/Sharing/shareable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShareable(_response);
        });
    }

    protected processGetShareable(response: Response): Promise<Shareable> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shareable.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Shareable>(null as any);
    }
}

export abstract class AuditableEntity implements IAuditableEntity {
    organizationId?: number;
    createdOn?: Date;
    createdBy?: string;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedByEmail?: string | undefined;
    modifiedByName?: string | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByName = _data["createdByName"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByEmail = _data["modifiedByEmail"];
            this.modifiedByName = _data["modifiedByName"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByName"] = this.createdByName;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByEmail"] = this.modifiedByEmail;
        data["modifiedByName"] = this.modifiedByName;
        return data;
    }
}

export interface IAuditableEntity {
    organizationId?: number;
    createdOn?: Date;
    createdBy?: string;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedByEmail?: string | undefined;
    modifiedByName?: string | undefined;
}

export class Assembly extends AuditableEntity implements IAssembly {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    components?: AssemblyComponent[] | undefined;
    compressedComponents?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;

    constructor(data?: IAssembly) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(AssemblyComponent.fromJS(item));
            }
            this.compressedComponents = _data["compressedComponents"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(AssemblyParameter.fromJS(item));
            }
            this.version = _data["version"];
            this.versionMessage = _data["versionMessage"];
            this.hashPartitionKey = _data["hashPartitionKey"];
            this.parentFolderId = _data["parentFolderId"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["compressedComponents"] = this.compressedComponents;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["versionMessage"] = this.versionMessage;
        data["hashPartitionKey"] = this.hashPartitionKey;
        data["parentFolderId"] = this.parentFolderId;
        super.toJSON(data);
        return data;
    }
}

export interface IAssembly extends IAuditableEntity {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    components?: AssemblyComponent[] | undefined;
    compressedComponents?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;
}

export class AssemblyDto extends Assembly implements IAssemblyDto {
    permissions?: ActionPermission | undefined;
    isPrivate?: boolean;

    constructor(data?: IAssemblyDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.permissions = _data["permissions"] ? ActionPermission.fromJS(_data["permissions"]) : <any>undefined;
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): AssemblyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        data["isPrivate"] = this.isPrivate;
        super.toJSON(data);
        return data;
    }
}

export interface IAssemblyDto extends IAssembly {
    permissions?: ActionPermission | undefined;
    isPrivate?: boolean;
}

export class ActionPermission implements IActionPermission {
    update?: boolean;
    delete?: boolean;
    duplicate?: boolean;
    createReference?: boolean;
    read?: boolean;
    changeStatus?: boolean;
    changeVisibility?: boolean;

    constructor(data?: IActionPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.update = _data["update"];
            this.delete = _data["delete"];
            this.duplicate = _data["duplicate"];
            this.createReference = _data["createReference"];
            this.read = _data["read"];
            this.changeStatus = _data["changeStatus"];
            this.changeVisibility = _data["changeVisibility"];
        }
    }

    static fromJS(data: any): ActionPermission {
        data = typeof data === 'object' ? data : {};
        let result = new ActionPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["update"] = this.update;
        data["delete"] = this.delete;
        data["duplicate"] = this.duplicate;
        data["createReference"] = this.createReference;
        data["read"] = this.read;
        data["changeStatus"] = this.changeStatus;
        data["changeVisibility"] = this.changeVisibility;
        return data;
    }
}

export interface IActionPermission {
    update?: boolean;
    delete?: boolean;
    duplicate?: boolean;
    createReference?: boolean;
    read?: boolean;
    changeStatus?: boolean;
    changeVisibility?: boolean;
}

export class AssemblyComponent implements IAssemblyComponent {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    parentAssembly?: Assembly | undefined;

    constructor(data?: IAssemblyComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(AssemblyParameter.fromJS(item));
            }
            this.parentAssembly = _data["parentAssembly"] ? Assembly.fromJS(_data["parentAssembly"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssemblyComponent {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["parentAssembly"] = this.parentAssembly ? this.parentAssembly.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssemblyComponent {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    parentAssembly?: Assembly | undefined;
}

export class AssemblyParameter implements IAssemblyParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    complexParameters?: AssemblyComplexParameter[] | undefined;
    parentComplexParameter?: AssemblyComplexParameter | undefined;
    parentComponent?: AssemblyComponent | undefined;

    constructor(data?: IAssemblyParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["complexParameters"])) {
                this.complexParameters = [] as any;
                for (let item of _data["complexParameters"])
                    this.complexParameters!.push(AssemblyComplexParameter.fromJS(item));
            }
            this.parentComplexParameter = _data["parentComplexParameter"] ? AssemblyComplexParameter.fromJS(_data["parentComplexParameter"]) : <any>undefined;
            this.parentComponent = _data["parentComponent"] ? AssemblyComponent.fromJS(_data["parentComponent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssemblyParameter {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.complexParameters)) {
            data["complexParameters"] = [];
            for (let item of this.complexParameters)
                data["complexParameters"].push(item.toJSON());
        }
        data["parentComplexParameter"] = this.parentComplexParameter ? this.parentComplexParameter.toJSON() : <any>undefined;
        data["parentComponent"] = this.parentComponent ? this.parentComponent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssemblyParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    complexParameters?: AssemblyComplexParameter[] | undefined;
    parentComplexParameter?: AssemblyComplexParameter | undefined;
    parentComponent?: AssemblyComponent | undefined;
}

export class AssemblyComplexParameter implements IAssemblyComplexParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    parentParameter?: AssemblyParameter | undefined;

    constructor(data?: IAssemblyComplexParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(AssemblyParameter.fromJS(item));
            }
            this.parentParameter = _data["parentParameter"] ? AssemblyParameter.fromJS(_data["parentParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssemblyComplexParameter {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyComplexParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["parentParameter"] = this.parentParameter ? this.parentParameter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssemblyComplexParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    parentParameter?: AssemblyParameter | undefined;
}

export class AssemblyHeader extends AuditableEntity implements IAssemblyHeader {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;

    constructor(data?: IAssemblyHeader) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(AssemblyParameter.fromJS(item));
            }
            this.version = _data["version"];
            this.versionMessage = _data["versionMessage"];
            this.hashPartitionKey = _data["hashPartitionKey"];
            this.parentFolderId = _data["parentFolderId"];
        }
    }

    static fromJS(data: any): AssemblyHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["versionMessage"] = this.versionMessage;
        data["hashPartitionKey"] = this.hashPartitionKey;
        data["parentFolderId"] = this.parentFolderId;
        super.toJSON(data);
        return data;
    }
}

export interface IAssemblyHeader extends IAuditableEntity {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: AssemblyParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;
}

export class AssemblyHeaderDto extends AssemblyHeader implements IAssemblyHeaderDto {
    isPrivate?: boolean;
    permissions?: ActionPermission | undefined;

    constructor(data?: IAssemblyHeaderDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isPrivate = _data["isPrivate"];
            this.permissions = _data["permissions"] ? ActionPermission.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssemblyHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrivate"] = this.isPrivate;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAssemblyHeaderDto extends IAssemblyHeader {
    isPrivate?: boolean;
    permissions?: ActionPermission | undefined;
}

export class GetAllAssembliesQuery implements IGetAllAssembliesQuery {

    constructor(data?: IGetAllAssembliesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllAssembliesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAssembliesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllAssembliesQuery {
}

export class GetAllAssembliesForOrganizationCompleteQuery implements IGetAllAssembliesForOrganizationCompleteQuery {

    constructor(data?: IGetAllAssembliesForOrganizationCompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllAssembliesForOrganizationCompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAssembliesForOrganizationCompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllAssembliesForOrganizationCompleteQuery {
}

export class GetAllAssembliesCompleteQuery implements IGetAllAssembliesCompleteQuery {

    constructor(data?: IGetAllAssembliesCompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllAssembliesCompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAssembliesCompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllAssembliesCompleteQuery {
}

export class GetAllAssembliesAndReferencesCompleteQuery implements IGetAllAssembliesAndReferencesCompleteQuery {

    constructor(data?: IGetAllAssembliesAndReferencesCompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllAssembliesAndReferencesCompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAssembliesAndReferencesCompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllAssembliesAndReferencesCompleteQuery {
}

export class SaveAssemblyCommand implements ISaveAssemblyCommand {
    assembly?: Assembly | undefined;

    constructor(data?: ISaveAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveAssemblyCommand {
    assembly?: Assembly | undefined;
}

export class DuplicateAssemblyCommand implements IDuplicateAssemblyCommand {
    assemblyId?: string;

    constructor(data?: IDuplicateAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assemblyId = _data["assemblyId"];
        }
    }

    static fromJS(data: any): DuplicateAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyId"] = this.assemblyId;
        return data;
    }
}

export interface IDuplicateAssemblyCommand {
    assemblyId?: string;
}

export class DuplicateAssemblyReferenceCommand implements IDuplicateAssemblyReferenceCommand {
    id?: string;

    constructor(data?: IDuplicateAssemblyReferenceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DuplicateAssemblyReferenceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateAssemblyReferenceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDuplicateAssemblyReferenceCommand {
    id?: string;
}

export class DuplicateReferenceToReferenceCommand implements IDuplicateReferenceToReferenceCommand {
    assembly?: Assembly | undefined;

    constructor(data?: IDuplicateReferenceToReferenceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateReferenceToReferenceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateReferenceToReferenceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDuplicateReferenceToReferenceCommand {
    assembly?: Assembly | undefined;
}

export class DeleteAssemblyCommand implements IDeleteAssemblyCommand {
    assemblyId?: string;
    version?: string | undefined;

    constructor(data?: IDeleteAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assemblyId = _data["assemblyId"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): DeleteAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblyId"] = this.assemblyId;
        data["version"] = this.version;
        return data;
    }
}

export interface IDeleteAssemblyCommand {
    assemblyId?: string;
    version?: string | undefined;
}

export class RefactorAssemblyCommand implements IRefactorAssemblyCommand {

    constructor(data?: IRefactorAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefactorAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefactorAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefactorAssemblyCommand {
}

export class RefactorSizeAssemblyCommand implements IRefactorSizeAssemblyCommand {

    constructor(data?: IRefactorSizeAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefactorSizeAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefactorSizeAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefactorSizeAssemblyCommand {
}

export class CopyToCosmosCommand implements ICopyToCosmosCommand {

    constructor(data?: ICopyToCosmosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyToCosmosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyToCosmosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyToCosmosCommand {
}

export class RefactorViewerAssemblyCommand implements IRefactorViewerAssemblyCommand {

    constructor(data?: IRefactorViewerAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefactorViewerAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefactorViewerAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefactorViewerAssemblyCommand {
}

export class SharePublicAssemblyCommand implements ISharePublicAssemblyCommand {

    constructor(data?: ISharePublicAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SharePublicAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SharePublicAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISharePublicAssemblyCommand {
}

export class CustomComponent extends AuditableEntity implements ICustomComponent {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: CustomComponentParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;

    constructor(data?: ICustomComponent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(CustomComponentParameter.fromJS(item));
            }
            this.version = _data["version"];
            this.versionMessage = _data["versionMessage"];
            this.hashPartitionKey = _data["hashPartitionKey"];
            this.parentFolderId = _data["parentFolderId"];
        }
    }

    static fromJS(data: any): CustomComponent {
        data = typeof data === 'object' ? data : {};
        let result = new CustomComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["versionMessage"] = this.versionMessage;
        data["hashPartitionKey"] = this.hashPartitionKey;
        data["parentFolderId"] = this.parentFolderId;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomComponent extends IAuditableEntity {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: CustomComponentParameter[] | undefined;
    version?: number;
    versionMessage?: string | undefined;
    hashPartitionKey?: string | undefined;
    parentFolderId?: string;
}

export class CustomComponentParameter implements ICustomComponentParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    complexParameters?: CustomComponentComplexParameter[] | undefined;
    parentComplexParameter?: CustomComponentComplexParameter | undefined;
    parentComponent?: CustomComponent | undefined;

    constructor(data?: ICustomComponentParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["complexParameters"])) {
                this.complexParameters = [] as any;
                for (let item of _data["complexParameters"])
                    this.complexParameters!.push(CustomComponentComplexParameter.fromJS(item));
            }
            this.parentComplexParameter = _data["parentComplexParameter"] ? CustomComponentComplexParameter.fromJS(_data["parentComplexParameter"]) : <any>undefined;
            this.parentComponent = _data["parentComponent"] ? CustomComponent.fromJS(_data["parentComponent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomComponentParameter {
        data = typeof data === 'object' ? data : {};
        let result = new CustomComponentParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.complexParameters)) {
            data["complexParameters"] = [];
            for (let item of this.complexParameters)
                data["complexParameters"].push(item.toJSON());
        }
        data["parentComplexParameter"] = this.parentComplexParameter ? this.parentComplexParameter.toJSON() : <any>undefined;
        data["parentComponent"] = this.parentComponent ? this.parentComponent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomComponentParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    complexParameters?: CustomComponentComplexParameter[] | undefined;
    parentComplexParameter?: CustomComponentComplexParameter | undefined;
    parentComponent?: CustomComponent | undefined;
}

export class CustomComponentComplexParameter implements ICustomComponentComplexParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: CustomComponentParameter[] | undefined;
    parentParameter?: CustomComponentParameter | undefined;

    constructor(data?: ICustomComponentComplexParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(CustomComponentParameter.fromJS(item));
            }
            this.parentParameter = _data["parentParameter"] ? CustomComponentParameter.fromJS(_data["parentParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomComponentComplexParameter {
        data = typeof data === 'object' ? data : {};
        let result = new CustomComponentComplexParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["parentParameter"] = this.parentParameter ? this.parentParameter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomComponentComplexParameter {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    parameters?: CustomComponentParameter[] | undefined;
    parentParameter?: CustomComponentParameter | undefined;
}

export class GetAllCustomComponentsQuery implements IGetAllCustomComponentsQuery {

    constructor(data?: IGetAllCustomComponentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllCustomComponentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCustomComponentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllCustomComponentsQuery {
}

export class SaveCustomComponentCommand implements ISaveCustomComponentCommand {
    component?: CustomComponent | undefined;

    constructor(data?: ISaveCustomComponentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.component = _data["component"] ? CustomComponent.fromJS(_data["component"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCustomComponentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCustomComponentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["component"] = this.component ? this.component.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCustomComponentCommand {
    component?: CustomComponent | undefined;
}

export class DeleteCustomComponentCommand implements IDeleteCustomComponentCommand {
    componentId?: string;

    constructor(data?: IDeleteCustomComponentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
        }
    }

    static fromJS(data: any): DeleteCustomComponentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomComponentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        return data;
    }
}

export interface IDeleteCustomComponentCommand {
    componentId?: string;
}

export class RefactorCustomComponentCommand implements IRefactorCustomComponentCommand {

    constructor(data?: IRefactorCustomComponentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefactorCustomComponentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefactorCustomComponentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefactorCustomComponentCommand {
}

export class RefactorSizeCustomComponentCommand implements IRefactorSizeCustomComponentCommand {

    constructor(data?: IRefactorSizeCustomComponentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefactorSizeCustomComponentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefactorSizeCustomComponentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefactorSizeCustomComponentCommand {
}

export class CopyToCosmosCommand2 implements ICopyToCosmosCommand2 {

    constructor(data?: ICopyToCosmosCommand2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyToCosmosCommand2 {
        data = typeof data === 'object' ? data : {};
        let result = new CopyToCosmosCommand2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyToCosmosCommand2 {
}

export class DirectoryFolder extends AuditableEntity implements IDirectoryFolder {
    id?: string;
    name?: string | undefined;
    children?: string[] | undefined;
    directoryType?: DirectoryType;

    constructor(data?: IDirectoryFolder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(item);
            }
            this.directoryType = _data["directoryType"];
        }
    }

    static fromJS(data: any): DirectoryFolder {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item);
        }
        data["directoryType"] = this.directoryType;
        super.toJSON(data);
        return data;
    }
}

export interface IDirectoryFolder extends IAuditableEntity {
    id?: string;
    name?: string | undefined;
    children?: string[] | undefined;
    directoryType?: DirectoryType;
}

export enum DirectoryType {
    Component = 0,
    SingleUseAssembly = 1,
    UnitOperation = 2,
}

export class GetAllDirectoriesFromOrganizationQuery implements IGetAllDirectoriesFromOrganizationQuery {

    constructor(data?: IGetAllDirectoriesFromOrganizationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllDirectoriesFromOrganizationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDirectoriesFromOrganizationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllDirectoriesFromOrganizationQuery {
}

export class DeleteDirectoryCommand implements IDeleteDirectoryCommand {
    id?: string;

    constructor(data?: IDeleteDirectoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteDirectoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDirectoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteDirectoryCommand {
    id?: string;
}

export class SaveDirectoryCommand implements ISaveDirectoryCommand {
    directoryFolder?: DirectoryFolder | undefined;

    constructor(data?: ISaveDirectoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directoryFolder = _data["directoryFolder"] ? DirectoryFolder.fromJS(_data["directoryFolder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveDirectoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDirectoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directoryFolder"] = this.directoryFolder ? this.directoryFolder.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveDirectoryCommand {
    directoryFolder?: DirectoryFolder | undefined;
}

export class CopyContainersCommand implements ICopyContainersCommand {

    constructor(data?: ICopyContainersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyContainersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyContainersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyContainersCommand {
}

export class ChangeDuplicateSameSuaCommand implements IChangeDuplicateSameSuaCommand {

    constructor(data?: IChangeDuplicateSameSuaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ChangeDuplicateSameSuaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDuplicateSameSuaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IChangeDuplicateSameSuaCommand {
}

export class AddAllSuaInHistoryCommand implements IAddAllSuaInHistoryCommand {

    constructor(data?: IAddAllSuaInHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddAllSuaInHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddAllSuaInHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAddAllSuaInHistoryCommand {
}

export class AddHashPartitionKeyCommand implements IAddHashPartitionKeyCommand {

    constructor(data?: IAddHashPartitionKeyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddHashPartitionKeyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddHashPartitionKeyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAddHashPartitionKeyCommand {
}

export class AddVersionHashPartitionKeyUoCommand implements IAddVersionHashPartitionKeyUoCommand {

    constructor(data?: IAddVersionHashPartitionKeyUoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddVersionHashPartitionKeyUoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddVersionHashPartitionKeyUoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAddVersionHashPartitionKeyUoCommand {
}

export class Shareable implements IShareable {
    id?: string | undefined;
    shareableContentId?: string;
    contentType?: string | undefined;
    isPrivate?: boolean;
    shareWith?: ShareToModel[] | undefined;
    except?: ShareToModel[] | undefined;

    constructor(data?: IShareable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shareableContentId = _data["shareableContentId"];
            this.contentType = _data["contentType"];
            this.isPrivate = _data["isPrivate"];
            if (Array.isArray(_data["shareWith"])) {
                this.shareWith = [] as any;
                for (let item of _data["shareWith"])
                    this.shareWith!.push(ShareToModel.fromJS(item));
            }
            if (Array.isArray(_data["except"])) {
                this.except = [] as any;
                for (let item of _data["except"])
                    this.except!.push(ShareToModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Shareable {
        data = typeof data === 'object' ? data : {};
        let result = new Shareable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shareableContentId"] = this.shareableContentId;
        data["contentType"] = this.contentType;
        data["isPrivate"] = this.isPrivate;
        if (Array.isArray(this.shareWith)) {
            data["shareWith"] = [];
            for (let item of this.shareWith)
                data["shareWith"].push(item.toJSON());
        }
        if (Array.isArray(this.except)) {
            data["except"] = [];
            for (let item of this.except)
                data["except"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShareable {
    id?: string | undefined;
    shareableContentId?: string;
    contentType?: string | undefined;
    isPrivate?: boolean;
    shareWith?: ShareToModel[] | undefined;
    except?: ShareToModel[] | undefined;
}

export class ShareToModel implements IShareToModel {
    id?: string;
    shareToType?: ShareToType;

    constructor(data?: IShareToModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shareToType = _data["shareToType"];
        }
    }

    static fromJS(data: any): ShareToModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareToModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shareToType"] = this.shareToType;
        return data;
    }
}

export interface IShareToModel {
    id?: string;
    shareToType?: ShareToType;
}

export enum ShareToType {
    User = 0,
    Group = 1,
}

export class ShareAssemblyCommand implements IShareAssemblyCommand {
    shareable?: Shareable | undefined;

    constructor(data?: IShareAssemblyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareable = _data["shareable"] ? Shareable.fromJS(_data["shareable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareAssemblyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ShareAssemblyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareable"] = this.shareable ? this.shareable.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareAssemblyCommand {
    shareable?: Shareable | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}